import routerOptions0 from "E:/New/aski-pwa-app-code/aski-pwa-app-code/aski-pwa-app-code/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}